import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';

export default function CookiesPage() {
  return (
    <LegalLayout title="Politique de Cookies" lastUpdated="Janvier 2025">
      <p className="italic text-linx_text-muted">
        La présente Politique de Cookies explique l'usage des cookies et technologies similaires sur le site LinxExpress et les services associés.
      </p>

      <LegalSection title="Que Sont les Cookies">
        <p>Les cookies sont de petits fichiers texte stockés sur votre navigateur ou appareil pour mémoriser certaines informations et améliorer le fonctionnement des services.</p>
      </LegalSection>

      <LegalSection title="Comment Nous Utilisons les Cookies">
        <p>Nous utilisons des cookies et traceurs comparables pour le fonctionnement du service, l'analyse et le marketing. Certains cookies sont indispensables au fonctionnement ; d'autres servent à mesurer la performance.</p>
      </LegalSection>

      <LegalSection title="Types de Cookies">
        <div className="space-y-4 mt-3">
          <div className="glow-card p-5">
            <h4 className="font-display text-sm font-semibold text-linx_text-primary mb-1">Cookies Essentiels</h4>
            <p className="text-sm">Nécessaires au fonctionnement principal du site/app, aux contrôles de sécurité, aux préférences de langue/thème et à la continuité de session.</p>
          </div>
          <div className="glow-card p-5">
            <h4 className="font-display text-sm font-semibold text-linx_text-primary mb-1">Cookies Analytiques</h4>
            <p className="text-sm">Utilisés pour comprendre l'usage du service et améliorer l'expérience via des indicateurs agrégés.</p>
          </div>
          <div className="glow-card p-5">
            <h4 className="font-display text-sm font-semibold text-linx_text-primary mb-1">Cookies Marketing</h4>
            <p className="text-sm">Utilisés pour adapter la pertinence des campagnes et mesurer l'efficacité marketing.</p>
          </div>
        </div>
      </LegalSection>

      <LegalSection title="Comment Contrôler les Cookies">
        <p>Vous pouvez configurer votre navigateur pour bloquer ou supprimer les cookies. Le blocage des cookies essentiels peut affecter la disponibilité ou la performance de certains services.</p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>Pour toute question sur les cookies : contact@agodevsolutions.com.</p>
      </LegalSection>
    </LegalLayout>
  );
}
